import * as actionTypes from './actionTypes';
const initialState = {
    loading: false,
    items: [],
    total: 0,
    readIds: [],
    unread: 0
};
export default (state = initialState, action) => {
    switch (action.type) {
        case actionTypes.UPDATE:
            return {
                ...state,
                loading: false,
                items: action.items,
                total: action.total,
                unread: action.items.map(i => i._id).filter(id => !state.readIds.includes(id)).length
            };
        case actionTypes.APPEND:
            return {
                ...state,
                loading: false,
                items: [...state.items, ...action.items],
                total: action.total + state.items.length,
            };
        case actionTypes.UPDATE_ONE:
            return {
                ...state,
                loading: false,
                items: state.items.map(i => {
                    if (i._id == action.item._id) {
                        return action.item;
                    }
                    else {
                        return i;
                    }
                }),
            };
        case actionTypes.EMPTY:
            return initialState;
        case actionTypes.LOADING:
            return {
                ...state,
                loading: true,
            };
        case actionTypes.READ_ITEM:
            const readIds = state.readIds.includes(action.item._id.toString()) ? state.readIds : [...state.readIds, action.item._id.toString()];
            return {
                ...state,
                readIds,
                unread: state.items.map(i => i._id.toString()).filter(id => !readIds.includes(id)).length
            };
        case actionTypes.READ_ALL:
            const readAllIds = state.items.map(i => i._id.toString());
            return {
                ...state,
                readIds: readAllIds,
                unread: state.items.map(i => i._id.toString()).filter(id => !readAllIds.includes(id)).length
            };
        default:
            return state;
    }
};
